

// <script src="https://www.gstatic.com/firebasejs/8.6.8/firebase-app.js"></script>
// <script src="https://www.gstatic.com/firebasejs/8.6.8/firebase-analytics.js"></script>

if (typeof importScripts !== 'undefined') {
  importScripts('https://www.gstatic.com/firebasejs/8.6.8/firebase-app.js');
  importScripts('https://www.gstatic.com/firebasejs/8.6.8/firebase-messaging.js');
}

const firebaseConfig = {
  apiKey: "AIzaSyAyPE91RrimRt7TMl99yYk1lDRZr1mSJ3Q",
  authDomain: "osmpro-a9699.firebaseapp.com",
  projectId: "osmpro-a9699",
  storageBucket: "osmpro-a9699.appspot.com",
  messagingSenderId: "969828274998",
  appId: "1:969828274998:web:100de3fcd734f91cdc9997",
  measurementId: "G-1PJHBD0DFP"
};

// firebase.initializeApp(firebaseConfig);
// firebase.analytics();

if (typeof importScripts !== 'undefined') {
  const firebaseApp = firebase.initializeApp(firebaseConfig);
  const messaging = firebase.messaging();
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = { firebaseConfig };
}

// console.log(messaging);


// import { getMessaging, getToken } from "firebase/messaging";

// // Get registration token. Initially this makes a network call, once retrieved
// // subsequent calls to getToken will return from cache.
// const messaging = getMessaging();
// getToken(messaging, { vapidKey: 'BJufx4x6pnGWpESdNBj7vl6wR74kO58H0bi2o1dYGi6yBY6Fqz8AhSjdQcmg8u_LWi95yt-O0zmw0ztR5sYsPc4' }).then((currentToken) => {
//   if (currentToken) {
//     // Send the token to your server and update the UI if necessary
//     // ...
//   } else {
//     // Show permission request UI
//     console.log('No registration token available. Request permission to generate one.');
//     // ...
//   }
// }).catch((err) => {
//   console.log('An error occurred while retrieving token. ', err);
//   // ...
// });
